export const CROSS_URL = "https://cors-anywhere.herokuapp.com/";

export const UPLOAD_URL = "https://dev-eduvanz.ind2s.sfdc-y37hzm.force.com/services/apexrest/HerokuFileUpload";

